// extracted by mini-css-extract-plugin
export default {"container":"Search_container__jg1Ve","content":"Search_content__Gyy+e"};